import httpClient from "./httpClient";

export async function upsertCouponVote(couponPublicId, value) {
  const { data } = await httpClient.post(
    `/coupons/${encodeURIComponent(couponPublicId)}/votes`,
    { value }
  );
  return data;
}

export async function removeCouponVote(couponPublicId) {
  const { data } = await httpClient.delete(
    `/coupons/${encodeURIComponent(couponPublicId)}/votes/me`
  );
  return data;
}
